import { Component } from "@angular/core";

@Component({
  selector: "app-solo-card",
  templateUrl: "./solo-card.component.html",
  styleUrls: ["./solo-card.component.scss"],
})
export class SoloCardComponent {
  otpCode: string;

  public onOtpEntered(otp: string): void {
    this.otpCode = otp;
  }
}
